export default __webpack_public_path__ + "static/media/volume_slash.b480614f.svg";